import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'

export const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/HomeView.vue'),
    meta: {
      layout: 'DefaultLayout',
      title: 'Caplena Survey',
    },
  },
  {
    // Respondent-facing collection runtime — rendered without an app layout.
    // Distribution URL shape: /s/<link_token>
    path: '/s/:linkToken',
    name: 'collect',
    component: () => import('@/views/CollectView.vue'),
    props: true,
    meta: {
      title: 'Share your feedback',
    },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/views/NotFoundView.vue'),
    meta: {
      layout: 'DefaultLayout',
      title: 'Page not found',
    },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: () => ({ top: 0 }),
})

router.afterEach((to) => {
  document.title = to.meta.title ? `${to.meta.title} | Caplena Survey` : 'Caplena Survey'
})

export default router
